import { Close, CloudUploadTwoTone } from '@material-ui/icons'
import { useState } from 'react'
import ErrorLine from 'components/ErrorLine'
import TimerProgress from 'components/mint/TimerProgress'
import { createRef } from 'react'
import { useEffect } from 'react'
import { getMaximumUpload } from 'controllers/CoreServiceController'
import { displayError } from 'util/screenUtils'
import { log } from 'components/utility/DisplayLog'

/** This function gets multiple media objects and displays them in a ScrollMenu.
 * The default number of media files is 6.
 * 
 * If mimeTypes is a non-empty array, it limits the types of files that can be selected.
 */
export default function MediaDrop({
  onSelected,
  prompt,
  multiple,
  mimeTypes = [],
  maxNumMedia = 6,
  dropWidth,
  close
}) {

  const [error, setError] = useState()
  const [completed, setCompleted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [maximumUploadBytes, setMaximumUploadBytes] = useState(0)
  const inputRef = createRef(null)

  const getFiles = (fileList) => {
    log('MediaDrop getFiles', fileList)
    setCompleted(false)
    setLoading(true)
    const selectedFiles = []
    setError()
    for (const file of fileList) {
      if (file.size > maximumUploadBytes) {
        log(`${file.name} is too large ${file.size}`)
        setError(`${file.name} is too large (maximum size is ${maximumUploadBytes / 1024 / 1024} megabytes)`)
        break
      }
      const typeIx = mimeTypes.findIndex((a) => a == file.type)
      if (typeIx === -1) {
        log(`${file.type} is not allowed`)
        setError(`${file.type} is not allowed`)
      } else {
        selectedFiles.push(file)
      }
      if (!multiple) {
        break
      }
    }
    if (selectedFiles.length) {
      log(`MediaDrop completed files ${selectedFiles.length}`)
      setCompleted(true)
      setLoading(false)
      onSelected(selectedFiles)
      //resizeAndSet(0, selectedFiles)
    }

  }

  const ignoreDrag = (e) => {
    e.stopPropagation()
    e.preventDefault()
  }

  const dropped = (e) => {
    ignoreDrag(e)
    const dt = e.dataTransfer
    getFiles(dt.files)
  }
  const selected = (e) => {
    getFiles(e.target.files)
  }

  /**
   * @see https://stackoverflow.com/questions/12030686/html-input-file-selection-event-not-firing-upon-selecting-the-same-file
   * @returns 
   */
  const displayMediaDropzone = () => {
    if (!(error || completed)) {
      log(`displayMediaDropzone`, mimeTypes)
      return (
        <div style={{ position: 'relative' }}>
          {mimeTypes.length ? <input
            type='file'
            id='fileDrop'
            ref={inputRef}
            multiple={multiple}
            accept={mimeTypes}
            onChange={selected}
            onClick={(evt) => evt.target.value = ''} //Do this so the same filename can be used in succession
            style={{ display: 'none' }}
          /> : <input
            type='file'
            id='fileDrop'
            ref={inputRef}
            multiple={multiple}
            onClick={(evt) => evt.target.value = ''} //Do this so the same filename can be used in succession
            onChange={selected}
            style={{ display: 'none' }}
          />}
          <div
            draggable='true'
            onDragStart={ignoreDrag}
            onDrop={dropped}
            onDragOver={ignoreDrag}
            style={{
              width: dropWidth ? dropWidth : '50vw',
              height: '15vh',
              border: '1px solid black',
              margin: 'auto',
              textAlign: 'center',
            }}
            onClick={(e) => {
              e.stopPropagation()
              inputRef.current.click()
            }}
          >
            {close ? <div style={{ position: 'absolute', right: '0.5em', top: 0, cursor: 'pointer' }} title='Close upload'>
              <Close style={{ fontSize: '2em', color: 'red' }} onClick={close} />
            </div> : null}
            <CloudUploadTwoTone color='primary' style={{ fontSize: '2em', cursor: 'pointer' }} />
            <p>{prompt ? prompt : `Drag and drop or click to select ${maxNumMedia > 1 ? 'files' : 'file'}`}</p>
          </div>
        </div>
      )
    }
  }
  /**
   * Note that input.accept only works as a filter on file dialog and not on what can actually
   * be received.
   * @returns
   */
  const displayDropAndFiles = () => {
    return (
      <div>
        {displayMediaDropzone()}
        <ErrorLine error={error} />
      </div>
    )
  }
  const displayLoadOrLoading = () => {
    log(`displayLoadOrLoading loading ${loading} error ${error} completed ${completed}`)
    return (
      <div>
        {!(error || completed) && loading ? <TimerProgress /> : displayDropAndFiles()}
      </div>
    )
  }

  useEffect(() => {
    getMaximumUpload()
      .then((response) => setMaximumUploadBytes(response.maximumUpload))
      .catch((error) => { displayError(error, setError) })
  }, [])
  return displayLoadOrLoading()
}
